export var RBAC_ACTIONS = {
    RBAC_VIEW_APPLICATION: 'RBAC:ViewApplication',
    RBAC_CREATE_APPLICATION: 'RBAC:CreateApplication',
    RBAC_UPDATE_APPLICATION: 'RBAC:UpdateApplication',
    RBAC_DELETE_APPLICATION: 'RBAC:DeleteApplication',
    RBAC_VIEW_APPLICATION_RESOURCE: 'RBAC:ViewApplicationResource',
    RBAC_CREATE_APPLICATION_RESOURCE: 'RBAC:CreateApplicationResource',
    RBAC_UPDATE_APPLICATION_RESOURCE: 'RBAC:UpdateApplicationResource',
    RBAC_DELETE_APPLICATION_RESOURCE: 'RBAC:DeleteApplicationResource',
    RBAC_VIEW_ALL_APPLICATIONS: 'RBAC:ViewAllApplications',
    RBAC_VIEW_CONFIGURATION: 'RBAC:ViewConfiguration',
    RBAC_CREATE_CONFIGURATION: 'RBAC:CreateConfiguration',
    RBAC_UPDATE_CONFIGURATION: 'RBAC:UpdateConfiguration',
    RBAC_DELETE_CONFIGURATION: 'RBAC:DeleteConfiguration',
    RBAC_VIEW_POLICY: 'RBAC:ViewPolicy',
    RBAC_CREATE_POLICY: 'RBAC:CreatePolicy',
    RBAC_UPDATE_POLICY: 'RBAC:UpdatePolicy',
    RBAC_DELETE_POLICY: 'RBAC:DeletePolicy',
    RBAC_VIEW_ALL_POLICIES: 'RBAC:ViewAllPolicies',
    RBAC_VIEW_ROLE: 'RBAC:ViewRole',
    RBAC_CREATE_ROLE: 'RBAC:CreateRole',
    RBAC_UPDATE_ROLE: 'RBAC:UpdateRole',
    RBAC_DELETE_ROLE: 'RBAC:DeleteRole',
    RBAC_VIEW_ALL_ROLES: 'RBAC:ViewAllRoles',
    RBAC_ASSIGN_ROLE: 'RBAC:AssignRole',
    RBAC_VIEW_ROLE_POLICY: 'RBAC:ViewRolePolicy',
    RBAC_CREATE_ROLE_POLICY: 'RBAC:CreateRolePolicy',
    RBAC_DELETE_ROLE_POLICY: 'RBAC:DeleteRolePolicy',
    RBAC_VIEW_ALL_ROLE_POLICIES: 'RBAC:ViewAllRolePolicies',
    RBAC_VIEW_USER: 'RBAC:ViewUser',
    RBAC_CREATE_USER: 'RBAC:CreateUser',
    RBAC_UPDATE_USER: 'RBAC:UpdateUser',
    RBAC_DELETE_USER: 'RBAC:DeleteUser',
    RBAC_VIEW_ALL_USERS: 'RBAC:ViewAllUsers',
    RBAC_UPDATE_ALL_USERS: 'RBAC:UpdateAllUsers',
    RBAC_VIEW_USER_GROUP: 'RBAC:ViewUserGroup',
    RBAC_CREATE_USER_GROUP: 'RBAC:CreateUserGroup',
    RBAC_UPDATE_USER_GROUP: 'RBAC:UpdateUserGroup',
    RBAC_DELETE_USER_GROUP: 'RBAC:DeleteUserGroup',
    RBAC_VIEW_ALL_USER_GROUPS: 'RBAC:ViewAllUserGroups',
    RBAC_ASSIGN_USER_GROUP: 'RBAC:AssignUserGroup',
    RBAC_VIEW_ORGANIZATION: 'RBAC:ViewOrganization',
    RBAC_CREATE_ORGANIZATION: 'RBAC:CreateOrganization',
    RBAC_UPDATE_ORGANIZATION: 'RBAC:UpdateOrganization',
    RBAC_DELETE_ORGANIZATION: 'RBAC:DeleteOrganization',
    RBAC_VIEW_ALL_ORGANIZATIONS: 'RBAC:ViewAllOrganizations',
    RBAC_VIEW_ALLOWED_ORIGIN: 'RBAC:ViewAllowedOrigin',
    RBAC_CREATE_ALLOWED_ORIGIN: 'RBAC:CreateAllowedOrigin',
    RBAC_UPDATE_ALLOWED_ORIGIN: 'RBAC:UpdateAllowedOrigin',
    RBAC_DELETE_ALLOWED_ORIGIN: 'RBAC:DeleteAllowedOrigin',
    RBAC_VIEW_NOTIFICATION: 'RBAC:ViewNotification',
    RBAC_UPDATE_NOTIFICATION: 'RBAC:UpdateNotification',
    RBAC_UPDATE_FEEDBACK: 'RBAC:UpdateFeedback',
    RBAC_DELETE_NOTIFICATION: 'RBAC:DeleteNotification'
};
export var EXPERIENCE_ACTIONS = {
    EXPERIENCE_CREATE_DATASET: 'EXPERIENCE:CreateDataset',
    EXPERIENCE_VIEW_DATASET: 'EXPERIENCE:ViewDataset',
    EXPERIENCE_DELETE_DATASET: 'EXPERIENCE:DeleteDataset',
    EXPERIENCE_UPDATE_DATASET: 'EXPERIENCE:UpdateDataset',
    EXPERIENCE_CREATE_SURVEY_RESPONSE: 'EXPERIENCE:CreateSurveyResponse',
    EXPERIENCE_VIEW_SURVEY_RESPONSE: 'EXPERIENCE:ViewSurveyResponse',
    EXPERIENCE_DELETE_SURVEY_RESPONSE: 'EXPERIENCE:DeleteSurveyResponse',
    EXPERIENCE_UPDATE_SURVEY_RESPONSE: 'EXPERIENCE:UpdateSurveyResponse'
};
export var ADMIN_ACCESS_ACTIONS = [RBAC_ACTIONS.RBAC_CREATE_USER, RBAC_ACTIONS.RBAC_CREATE_ROLE, RBAC_ACTIONS.RBAC_CREATE_POLICY, RBAC_ACTIONS.RBAC_UPDATE_USER, RBAC_ACTIONS.RBAC_UPDATE_ROLE, RBAC_ACTIONS.RBAC_UPDATE_POLICY, RBAC_ACTIONS.RBAC_UPDATE_CONFIGURATION, RBAC_ACTIONS.RBAC_VIEW_CONFIGURATION];
